import { combineReducers } from "redux";

import { credentialsReducer } from "./Credentials/reducer";
import { credentialsTypesReducer } from "./CredentialsTypes/reducer";

export const credentialsManagerReducer = combineReducers({
    credentialsReducer: credentialsReducer,
    credentialsTypesReducer: credentialsTypesReducer,
});
